module.exports = {
  fraNo: 'Fra nº: ',
  localeName: 'ca-ES',
  momentFormat: 'DD/MM/YYYY',
  nikeRetailBranch: 'Nike Retail Sucursal en España',
  originalInvoiceNumber: 'Factura Orig nº: ',
  taxId: 'N.I.F: ',
};
